export const APP_STORE_EXPANDED_BY_DEFAULT = 'console-expanded-by-default'
export const APPBUILDER_DEVELOPMENT_FEATURES = 'console-app-builder-development-features'
export const APPBUILDER_FEATURE_CATEGORIES = 'console-app-builder-feature-categories'
export const AUDIT_API = 'console-audit-api'
export const SPACE_PUBLISHER = 'console-space-publisher'
export const SPACE_NOTIFICATOR = 'console-space-notificator'
export const SPACE_APPS = 'console-space-apps'
export const CHANNEL_CONNECTIONS_SHAREPOINT = 'console-organization-channel-connections-sharepoint'
export const CHANNEL_CONNECTIONS_OIDC = 'console-organization-channel-connections-oidc'
export const ASK_V3_BATCH_TESTING = 'ask-api-v3-batch-testing'
export const TRIAL_TENANT = 'trial-tenant'
export const KNOWLEDGE_V3_OPEN_SEARCH = 'ask-api-v3-use-new-open-search'
export const CONSOLE_WORKSHOP_RESPONSE_TYPE = 'console-workshop-response-type'
export const CHATBOT_CONVERSATION_LOGS = 'chatbot-conversation-logs'
export const BUILDER_ORG_ADMIN_ACCESS = 'app-builder-org-admin-datasource-access'
export const WORKSHOP_AGENTS = 'console-workshop-agents'
export const BUILDER_PRO_CODE_APPS = 'app-builder-pro-code-apps'
export const BEDROCK_KNOWLEDGE_SERVICE = 'console-bedrock-knowledge-service'
